export default __webpack_public_path__ + "static/media/new-timer-icon.2017c100.svg";